export default class ApplicationSettingsWriteDTO {
    public emailRandD: string | undefined;
    public emailSampleProducer: string | undefined;
    public emailSampleProcessOwner: string | undefined;
    public emailSampleMaintainer: string | undefined;
    public emailDEP: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.emailRandD = data['emailRandD'];
        this.emailSampleProducer = data['emailSampleProducer'];
        this.emailSampleProcessOwner = data['emailSampleProcessOwner'];
        this.emailSampleMaintainer = data['emailSampleMaintainer'];
        this.emailDEP = data['emailDEP'];
    }
}
